import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import CustomButton from 'components/CustomButton';
import StartAssessmentDialog from 'dialogs/StartAssessmentDialog';
import NoAccessTooltip from 'components/NoAccessTooltip';
import { useCaseMasterAccessData } from 'components/CaseMaster/CaseMasterAccessContext';
import CaseMasterLockMessage from 'components/CaseMaster/CaseMasterLockMessage';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    height: '124px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `2px solid ${theme.palette.neutral['clr-200']}`,
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.shades['clr-white-900'],
    padding: theme.spacing(8)
  }
}));

const Reattempt = ({ caseMaster }) => {
  const classes = useStyles();

  const [openAssessmentDialog, setOpenAssessmentDialog] = useState(false);

  // This page lives outside the dashboard provider, so resolve access standalone.
  // Viewing feedback means the case is finished — a free user has spent their one
  // attempt (freeAttemptUsed) and an expired Pro plan blocks reattempts too.
  const { getLockInfo } = useCaseMasterAccessData();
  const { locked, message: lockMessage, upgradeUrl, linkText } = getLockInfo(caseMaster?._id);

  return (
    <Box className={classes.container}>
      <Box display='flex' gap='16px' alignItems='center'>
        <img 
          src='https://assets.languify.in/gifs/rocket.gif'
          width={108}
          height={60}
          alt='rocket'
        />
        <Box display='flex' flexDirection='column' gap='8px'>
          <Typography variant='h4-medium' color='neutral.clr-900'>
            Reattempts significantly improve overall score.
          </Typography>
          <Typography variant='h6-medium' color='neutral.clr-600'>
            Give this another shot!
          </Typography>
        </Box>
      </Box>
      <NoAccessTooltip
        show={locked}
        message={
          <CaseMasterLockMessage
            message={lockMessage} upgradeUrl={upgradeUrl} linkText={linkText}
          />
        }
      >
        <CustomButton
          onClick={() => setOpenAssessmentDialog(true)}
          disabled={locked}
          startIcon={locked ? <LockOutlinedIcon sx={{ fontSize: '18px' }} /> : undefined}
        >
          Reattempt
        </CustomButton>
      </NoAccessTooltip>
      <StartAssessmentDialog
        onClose={() => setOpenAssessmentDialog(false)}
        open={openAssessmentDialog}
        template={{ _id: caseMaster?._id, name: caseMaster?.title, type: 'case_master' }}
        codingInterview={false}
      />
    </Box>
  );
};

export default Reattempt;

